import BankSummary from '@square/dashboard-data/models/squareup/simple-instrument-store/api/bank-summary';
import CardSummary from '@square/dashboard-data/models/squareup/simple-instrument-store/api/card-summary';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  token: attr(String),
  card: attr(CardSummary),
  bank: attr(BankSummary),
  active: attr(Boolean),
  nickname: attr(String),
  metadata: attr(String)
});